import { render, staticRenderFns } from "./TheODS.vue?vue&type=template&id=49e1ae7a&scoped=true&"
import script from "./TheODS.vue?vue&type=script&lang=js&"
export * from "./TheODS.vue?vue&type=script&lang=js&"
import style0 from "./TheODS.vue?vue&type=style&index=0&id=49e1ae7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e1ae7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Volumes/Crucial2TB/Main Portfolio/TOTUMO/Projects/Man Power/Experis/reporte-novedades/ctg-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCalendar } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSheet } from 'vuetify/lib'
installComponents(component, {VBtn,VCalendar,VContainer,VDivider,VFlex,VLayout,VSelect,VSheet})
